import { render } from "./SpicyBowlsView.vue?vue&type=template&id=6702ac3f"
import script from "./SpicyBowlsView.vue?vue&type=script&lang=js"
export * from "./SpicyBowlsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__